import { render, staticRenderFns } from "./RevenuesTabs.vue?vue&type=template&id=623a405e&"
import script from "./RevenuesTabs.vue?vue&type=script&lang=js&"
export * from "./RevenuesTabs.vue?vue&type=script&lang=js&"
import style0 from "./RevenuesTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports